import Api from '../../../../../lib/api';
import * as types from './types';

export const setFetchingDocumentTypes = (fetching) => {
  return {
    type: types.SET_FETCHING_DOCUMENT_TYPES_SETTINGS,
    payload: fetching
  };
};

export const setDocumentTypesError = (error) => {
  return {
    type: types.SET_DOCUMENT_TYPES_SETTINGS_ERROR,
    payload: error
  };
};

export const setDocumentTypesList = (list) => {
  return {
    type: types.SET_DOCUMENT_TYPES_SETTINGS_LIST,
    payload: list
  };
};

export const setTotalAmountOfDocumentTypes = (total) => {
  return {
    type: types.SET_TOTAL_AMOUNT_OF_DOCUMENT_TYPES_SETTINGS,
    payload: total
  };
};

export const addDocumentTypesError = (error) => {
  return {
    type: types.SET_DOCUMENT_TYPES_SETTINGS_ADD_ERROR,
    payload: error
  };
};

export const addDocumentTypesSuccess = () => {
  return {
    type: types.SET_DOCUMENT_TYPES_SETTINGS_ADD_SUCCESS,
  };
};

export const addDocumentTypesFetching = () => {
  return {
    type: types.SET_DOCUMENT_TYPES_SETTINGS_ADD_FETCHING,
  };
};


export const setShowModal = (status) => {
  return {
    type: types.SET_DOCUMENT_TYPES_SETTINGS_SHOW_MODAL,
    payload: status
  };
};

export const fetchDocumentTypes = (queryParams) => {
  return (dispatch, getState) => {
    const { login, localization } = getState();
    let {
      error10005,
      error10006,
      error10007,
      error10011,
      error10019,
      errorDefault,
      errorConnection,
    } = localization.strings.hcProfile.projects.actions; //TODO: ADD LOCALIZATION
    const token = login.authToken;
    let urlParameters = '';

    dispatch(setFetchingDocumentTypes(true));
    dispatch(setTotalAmountOfDocumentTypes(0));

    const { documentTypesPerPage } = getState().documentTypesSettings;

    if (queryParams) {
      if (!queryParams.pageNumber) {
        queryParams.pageNumber = 1;
      }
      queryParams.pageSize = documentTypesPerPage;
    } else {
      queryParams = {
        pageNumber: 1,
        pageSize: documentTypesPerPage
      };
    }

    let urlQuery = 'cf/documentTypes';

    urlParameters = `?${Object.keys(queryParams).map(i => `${i}=${queryParams[i]}`).join('&')}`;

    return Api.get(`${urlQuery}${urlParameters}`, token)
      .then(response => {
        const { success, data, totalCount } = response.data;        
        let errorMsg = '';
        if (success) {
          dispatch(setTotalAmountOfDocumentTypes(totalCount ? totalCount : 0));
          dispatch(setDocumentTypesList(data ? data : []));
        } else {
          switch (data.errorCode) {
            case 10005:
              errorMsg = error10005;
              break;
            case 10006:
              errorMsg = error10006;
              break;
            case 10007:
              errorMsg = error10007;
              break;
            case 10011:
              errorMsg = error10011;
              break;
            case 10019:
              errorMsg = error10019;
              break;
            default:
              errorMsg = errorDefault;
              break;
          }
          dispatch(setDocumentTypesError(errorMsg));
          dispatch(setTotalAmountOfDocumentTypes(0));
        }
      })
      .catch(() => {
        dispatch(setDocumentTypesError(errorConnection));
      });
  };
};

export const sendDocumentTypes = (input, closeModal) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();

    const {
      errorDefault,
      errorConnection,
    } = localization.strings.certFocusProjects.errors;

    dispatch(addDocumentTypesFetching());

    let apiMethod;
    
    if (input.documentTypeId) {
      apiMethod = 'put';
    } else {
      apiMethod = 'post';
    }

    return Api[apiMethod](`cf/documentTypes`, input, authToken)
      .then(response => {
        const { success } = response.data;

        if (success) {
          dispatch(addDocumentTypesSuccess());
          closeModal(true);
        } else {
          dispatch(addDocumentTypesError(errorDefault));
        }
      })
      .catch(() => {
        dispatch(addDocumentTypesError(errorConnection));
      });
  };
};

export const deleteDocumentTypes = (input, callback) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();

    const {
      errorDefault,
      errorConnection,
    } = localization.strings.certFocusProjects.errors;

    dispatch(addDocumentTypesFetching());
    
    return Api.delete(`cf/documentTypes`, input, authToken)
      .then(response => {
        const { success } = response.data;

        if (success) {
          dispatch(addDocumentTypesSuccess());
          callback(true);
        } else {
          dispatch(addDocumentTypesError(errorDefault));
          callback(false);
        }
      })
      .catch(() => {
        dispatch(addDocumentTypesError(errorConnection));
        callback(false);
      });
  };
};
